module.exports = __webpack_public_path__ + "img/30.f592c9a4.png";